export default __webpack_public_path__ + "static/media/ourStory.c428a1b3.jpeg";